import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b335bace = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _2787455e = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _12f7c774 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _53f3442a = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _735080ca = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _f5ca2d28 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _44036d2a = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _d9be78f6 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _6e44c764 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _28a9b822 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _f2d33cfa = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _506e356d = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _5bcc6273 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _9f2d2e6c = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _2654d3c2 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _e89cc1a6 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _86946258 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _c2becbec = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _cb4c05de = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _c8c5671e = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _51bed4b4 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _3874b3a8 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _0cb3965c = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _98f162de = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _26cbb717 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _a866ab24 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _b02bb7a0 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _8ee82fdc = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _a6777620 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _011b2bf8 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _cb97bba2 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _1f3406fe = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _d13260ea = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _bf6dc27a = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _aa626076 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _5bc58a02 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _5f425e5a = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _d7461338 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _5812c8da = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _64a5ebd6 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _599c4bd6 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _7f3a68e2 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _010eab9d = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _5f0c2830 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _31d5ce33 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _148a4302 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _4336b7ae = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _0a2d767a = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _3c91b18b = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _239f1249 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _8193dae0 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _eba29750 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _76225787 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _d3b4c80e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4dd45da8 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _1904c3de = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _438e769c = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _349d3ded = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _bd2578d0 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _2682c97a = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _0b479a27 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _d88e720c = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _062d8e9a = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _4bf4142a = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _8eafa17c = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _79dcf741 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _3cf916dc = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _0d33c9a6 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _7c87a49c = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _18225a36 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _5444e8ab = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _16ed57e3 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _a6482612 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _2e06d6b6 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _2820adf3 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _0af4af15 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _b335bace,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _2787455e,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _12f7c774,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _53f3442a,
    name: "calendar"
  }, {
    path: "/customer",
    component: _735080ca,
    name: "customer"
  }, {
    path: "/details",
    component: _f5ca2d28,
    name: "details"
  }, {
    path: "/goals",
    component: _44036d2a,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _d9be78f6,
    name: "maisoku"
  }, {
    path: "/media",
    component: _6e44c764,
    name: "media"
  }, {
    path: "/privacy",
    component: _28a9b822,
    name: "privacy"
  }, {
    path: "/project",
    component: _f2d33cfa,
    name: "project"
  }, {
    path: "/response",
    component: _506e356d,
    name: "response"
  }, {
    path: "/sale",
    component: _5bcc6273,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _9f2d2e6c,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _2654d3c2,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _e89cc1a6,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _86946258,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _c2becbec,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _cb4c05de,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _c8c5671e,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _51bed4b4,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _3874b3a8,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _0cb3965c,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _98f162de,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _26cbb717,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _a866ab24,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _b02bb7a0,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _8ee82fdc,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _a6777620,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _011b2bf8,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _cb97bba2,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _1f3406fe,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _d13260ea,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _bf6dc27a,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _aa626076,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _5bc58a02,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _5f425e5a,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _d7461338,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _5812c8da,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _64a5ebd6,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _599c4bd6,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _7f3a68e2,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _010eab9d,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _5f0c2830,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _31d5ce33,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _148a4302,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _4336b7ae,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _0a2d767a,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _3c91b18b,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _239f1249,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _8193dae0,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _eba29750,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _76225787,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _d3b4c80e,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _4dd45da8,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _1904c3de,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _438e769c,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _349d3ded,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _bd2578d0,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _2682c97a,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _0b479a27,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _d88e720c,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _062d8e9a,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _4bf4142a,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _8eafa17c,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _79dcf741,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _3cf916dc,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _0d33c9a6,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _7c87a49c,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _18225a36,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _5444e8ab,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _16ed57e3,
    name: "property-property",
    children: [{
      path: "contact",
      component: _a6482612,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _2e06d6b6,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _2820adf3,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _0af4af15,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
